<anagrafica-parte-form
  [isParteForm]="true"
  (parteChange)="onEmitAnagrafica($event)"
  [parte]="parte"
  *ngIf="currentForm == form.ANAGRAFICA">
</anagrafica-parte-form>
<associazione-controparte-form
[primariaPreselected] = "controparti.length === 0"
[parte]="parte"
(onReturn)="onEmitAssociativa($event)"
*ngIf="currentForm == form.ASSOCIATIVA"></associazione-controparte-form>
